import styled from 'styled-components';
import { styles } from '../../../consts';

const { fontMontserrat } = styles;

const Wrapper = styled.div`
  padding: 1rem 0.75rem 1rem;
  display: flex;
  flex-direction: column;
  align-self: center;
  justify-content: space-between;
`;

const ItemBold = styled.p`
  height: 1.5rem;
  line-height: 1.5rem;
  font-family: ${fontMontserrat};
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 0.015625rem;
`;

const Item = styled.p`
  height: 1.25rem;
  line-height: 1.25rem;
  font-family: ${fontMontserrat};
  font-size: 0.75rem;
  font-weight: 300;
  letter-spacing: 0.015625rem;
`;

const Description = styled.div`
  font-weight: 300;
  font-size: 0.75rem;
  line-height: 1.25rem;
  margin: 0.5rem 0;
  letter-spacing: 0.015625rem;
  overflow-wrap: break-word;

  .statusbar-mobile__description {
    font-weight: bold;
  }
`;

export { Item, ItemBold, Description, Wrapper };
